import InputField from "components/fields/InputField";
import Checkbox from "components/checkbox";
import { Link } from "react-router-dom";

const Register: React.FC = () => {
  // const [verified, setVerified] = useState(false);
  // const recaptchaRef = useRef<any>(null);

  // const onReCAPTCHAChange = (value: any) => {
  //   console.log("Captcha value:", value);
  //   if (value) {
  //     setVerified(true);
  //   }
  // };

  // const handleSubmit = (e: Event) => {
  //   e.preventDefault();
  //   if (!verified) {
  //     alert("Please verify that you are a human!");
  //     return;
  //   }
  //   alert("Form submitted successfully!");
  //   // Handle form submission logic here
  // };

  return (
    <div className="mb-6 mt-12 flex items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="box w-full max-w-[510px] flex-col items-center overflow-hidden bg-white px-5 py-[39px] dark:bg-darkPrimary md:mx-auto md:w-auto md:px-[78px]">
        <h4 className="text-h1 mb-2.5 text-center text-navy-700 dark:text-white">
          Sign Up
        </h4>
        <p className="text-medium mb-6 ml-1 text-center text-gray-700">
          Track, Analyze, and Stay Ahead with Ease
        </p>
        {/* Email */}
        <InputField
          variant="auth"
          extra="mb-5 md:min-w-[350px]"
          label="Email"
          placeholder="Email"
          id="email"
          type="text"
          required={true}
        />

        {/* Password */}
        <InputField
          variant="auth"
          extra="mb-5 md:min-w-[350px]"
          label="Password"
          placeholder="Enter your password"
          id="password"
          type="password"
          required={true}
          ispassword={true}
        />

        <InputField
          variant="auth"
          extra="mb-5 md:min-w-[350px]"
          label="Confirm Password"
          placeholder="Enter your password"
          id="password"
          type="password"
          required={true}
          ispassword={true}
        />

        {/* <ReCAPTCHA
          className="mb-5"
          sitekey="6LdFvLIqAAAAACtgulhcxC2nrp38IN_Agh3dk1rL" // Replace with your Site Key
          onChange={onReCAPTCHAChange}
          ref={recaptchaRef}
        /> */}

        <div className="mb-4 flex items-center">
          <Checkbox extra="mr-3" />
          <span className="dark:text-gray-700">
            I agree to the{" "}
            <span className="text-green-900">Terms and Conditions</span>.
          </span>
        </div>
        <div className="mb-5 flex items-center">
          <Checkbox extra="mr-3" />
          <span className="dark:text-gray-700">
            I would like to receive the BBAScan newsletter and understand that I
            can <span className="mx-1 text-green-900">unsubscribe</span> at any
            time.
          </span>
        </div>
        <button className="linear btn w-full">Create Account</button>
        <div className="mt-6 text-center">
          <span className="dark:text-gray-700">Already registered?</span>
          <Link
            to="/login"
            className="ml-1 text-green-900 hover:text-brand-600"
          >
            Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
